import React, { useContext, useState } from "react";
import "../css/receivefunds.css";
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { FirebaseContext } from "../../../context/firebase";

const useStyles = makeStyles((theme: Theme) => {
    return {
        navIcon: {
            color: '#999 !important',
            fontSize: '1.7rem !important',
            fontWeight: '900 !important'
        },
        logo: {
            transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
            margin: '0 auto'
        },
        logoHolder: {
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
        paragraph: {
          lineHeight: 1.6,
          color: '#555',
          fontSize: '0.978rem',
          fontStyle: 'normal',
          textAlign: 'left',
          fontWeight: '400',
          marginBottom: '30px'
      },
      footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '1rem',
        [theme.breakpoints.down('md')]: {
          padding: '0rem',
        },
      },
      linkButton: {
        color: '#fff !important',
        backgroundColor: '#5d307f',
        borderColor: '#5d307f',
        marginLeft: '10px',
        display: 'inline-block',
        fontWeight: 400,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        border: '1px solid transparent',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '0.25rem',
        textDecoration: 'none',
        transition: 'all 0.15s ease-in-out',
        "&:hover": {
          color: '#000 !important',
          backgroundColor: '#e37927',
          borderColor: '#e37927',
        },
        [theme.breakpoints.down('sm')]: {
          marginLeft: '0',
          marginTop: '5px',
          display: 'block'
        },
      },
      asideInner: {
        padding: '1rem',
        width: '100%',
        height: '100%',
        [theme.breakpoints.down('md')]: {
          padding: '1rem',
        },
      },
      tabContainer: {
        display: 'flex',
        marginBottom: '20px',
        borderBottom: '2px solid #eee',
        width: '100%',
      },
      tab: {
        flex: 1,
        padding: '10px 5px',
        background: 'none',
        border: 'none',
        fontSize: '0.95rem',
        fontWeight: 600,
        cursor: 'pointer',
        color: '#777',
        textAlign: 'center',
        outline: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&.active': {
          color: '#5d307f',
          borderBottom: '2px solid #5d307f',
          marginBottom: '-2px',
        }
      },
      qrContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '15px 0',
        padding: '10px',
        background: '#f9f9f9',
        borderRadius: '8px',
        border: '1px solid #eaeaea'
      },
      qrImage: {
        width: '130px',
        height: '130px',
        borderRadius: '4px',
        padding: '4px',
        background: '#fff',
        border: '1px solid #ddd'
      }
    }
});

interface Props {
  handleTopupClose: () => void;
}

const ReceiveFundsPopup: React.FC<Props> = ({ handleTopupClose }) => {
    const { data } = useContext(FirebaseContext);
    const classes = useStyles();
    
    const [activeTab, setActiveTab] = useState<'bank' | 'crypto'>('bank');
    const [selectedCrypto, setSelectedCrypto] = useState<'USDT' | 'BTC' | 'ETH' | 'BNB' | 'BITCOIN'>('USDT');

  const accountDetails = {
    accountName: data?.name || '',
    accountNumber: data?.accountNumber || '',
    routingNumber: data?.routingNUmber || '',
    bankName: data?.bankName || '',
    swiftCode: data?.swiftCode || '',
    accountType: data?.accountType || '',
    bankAddress: data?.bankAddress || '',
  };

  const getCryptoConfig = () => {
    switch (selectedCrypto) {
      case 'USDT':
        return {
          coin: 'USDT',
          network: 'TRC20 (Tron)',
          walletAddress: data?.cryptoWallets?.USDT || 'TZD4ugRkt6Lro9TB2RYF81T2YiPW1RDv5r',
        };
      case 'BNB':
        return {
          coin: 'BNB',
          network: 'BNB Smart Chain (BEP20)',
          walletAddress: data?.cryptoWallets?.BNB || '0xfEe9F6056a5291EDdDa0Cd849795A95098bDDbF4',
        };
      case 'BITCOIN':
        return {
          coin: 'BITCOIN',
          network: 'Bitcoin Network',
          walletAddress: data?.cryptoWallets?.BITCOIN || 'bc1phanq9vlrp6daj3dplcslverx4he8mrccz4pyxs8e3dxqak0r0xzssv4zwu',
        };
      case 'ETH':
        return {
          coin: 'ETH',
          network: 'Ethereum (ERC20)',
          walletAddress: data?.cryptoWallets?.ETH || '0xfEe9F6056a5291EDdDa0Cd849795A95098bDDbF4',
        };
      default:
        return {
          coin: selectedCrypto,
          network: 'Standard Network',
          walletAddress: '0xYourDefaultCryptoWalletAddressHere...',
        };
    }
  };

  const cryptoDetails = getCryptoConfig();

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const copyAll = () => {
    const details = Object.entries(accountDetails)
      .map(([key, value]) => `${key.replace(/([A-Z])/g, " $1")}: ${value}`)
      .join("\n");
    navigator.clipboard.writeText(details);
  };

  return (
    <div id='sidebar-wrapper-receive-funds' className='sidebar-wrapper-receive-funds'>
       <aside className='sidebar-receive-funds'>
          <div className={classes.asideInner}>
           <button type="button" className="btn-receive-funds close" onClick={handleTopupClose}>×</button>
        </div>

            {/* Tab Navigation */}
            <div className={classes.tabContainer}>
              <button 
                className={`${classes.tab} ${activeTab === 'bank' ? 'active' : ''}`}
                onClick={() => setActiveTab('bank')}
              >
                Bank Transfer
              </button>
              <button 
                className={`${classes.tab} ${activeTab === 'crypto' ? 'active' : ''}`}
                onClick={() => setActiveTab('crypto')}
              >
                Crypto Deposit
              </button>
            </div>

            {activeTab === 'bank' ? (
              <>
                <p className="sub-text">
                    Share your verified bank details below to receive domestic or
                    international transfers securely.
                </p>

                <div className="account-info">
                    {Object.entries(accountDetails).map(([key, value]) => (
                    <div className="info-row" key={key}>
                        <span className="label">
                        {key.replace(/([A-Z])/g, " $1")}
                        </span>
                        <span className="value">{value}</span>
                        <button
                        className="copy-btn"
                        onClick={() => copyToClipboard(value)}
                        title="Copy to clipboard"
                        >
                        📋
                        </button>
                    </div>
                    ))}
                </div>

                <button className="copy-all" onClick={copyAll}>
                    Copy All Details
                </button>

                <div className="international-info">
                    <h4>International Transfers</h4>
                    <p>
                    For transfers from outside the U.S., provide the sender with your
                    <strong> SWIFT Code</strong>, <strong>Routing Number</strong>, and{" "}
                    <strong>Account Number</strong>. Funds are usually available within{" "}
                    1–3 business days.
                    </p>
                </div>
              </>
            ) : (
              <>
                <p className="sub-text">
                    Select a cryptocurrency and network to deposit funds securely to your wallet.
                </p>

                {/* Crypto selector buttons */}
                <div style={{ display: 'flex', gap: '8px', marginBottom: '15px', flexWrap: 'wrap' }}>
                  {(['USDT', 'BNB', 'BITCOIN', 'ETH'] as const).map((coin) => (
                    <button 
                      key={coin}
                      onClick={() => setSelectedCrypto(coin)}
                      style={{
                        padding: '6px 12px',
                        borderRadius: '4px',
                        border: selectedCrypto === coin ? '1px solid #5d307f' : '1px solid #ccc',
                        background: selectedCrypto === coin ? '#5d307f' : '#fff',
                        color: selectedCrypto === coin ? '#fff' : '#333',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {coin}
                    </button>
                  ))}
                </div>

                {/* QR Code Display Section */}
                <div className={classes.qrContainer}>
                  <img 
                    src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(cryptoDetails.walletAddress)}`} 
                    alt={`${selectedCrypto} QR Code`}
                    className={classes.qrImage}
                  />
                  <span style={{ fontSize: '0.8rem', color: '#666', marginTop: '6px' }}>
                    Scan to pay with mobile wallet
                  </span>
                </div>

                <div className="account-info">
                    <div className="info-row">
                        <span className="label">Network</span>
                        <span className="value">{cryptoDetails.network}</span>
                    </div>
                    <div className="info-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                        <span className="label" style={{ marginBottom: '5px' }}>Wallet Address</span>
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span className="value" style={{ wordBreak: 'break-all', fontSize: '0.85rem' }}>{cryptoDetails.walletAddress}</span>
                          <button
                            className="copy-btn"
                            onClick={() => copyToClipboard(cryptoDetails.walletAddress)}
                            title="Copy to clipboard"
                          >
                            📋
                          </button>
                        </div>
                    </div>
                </div>

                <div className="international-info" style={{ marginTop: '15px' }}>
                    <h4>Important Notice</h4>
                    <p>
                      Send only <strong>{selectedCrypto}</strong> to this address using the correct network. Sending any other asset may result in permanent loss of funds.
                    </p>
                </div>
              </>
            )}

      </aside>
    </div>
  )
}

export default ReceiveFundsPopup;